export const GBT_FINDER_URL = "https://finder.switchtogbt.com/it";

export const GBT_CERT = {
  holder: "Dott. Nicola Mauro",
  number: "EMS_IT-24-00101456",
  obtained: "Bologna, 31/07/2024",
  issuer: "Swiss Dental Academy — EMS",
};

export const GBT_STEPS = [
  { n: "01", title: "Valutazione e prevenzione delle infezioni", text: "Sciacquo antibatterico pre-trattamento e controllo accurato di gengive, denti e impianti: si parte sempre da una diagnosi." },
  { n: "02", title: "Rivelare il biofilm", text: "Un rivelatore di placca colora il biofilm, rendendolo visibile a te e a noi. Si lavora solo dove serve, niente di più." },
  { n: "03", title: "Motivazione", text: "Guardando i colori capisci dove lo spazzolino non arriva: ti mostriamo come migliorare l'igiene a casa, con semplicità." },
  { n: "04", title: "AIRFLOW®", text: "Un getto tiepido di aria, acqua e polvere finissima di eritritolo (AIRFLOW® PLUS) rimuove biofilm, macchie e tartaro giovane, anche sotto gengiva fino a 4 mm." },
  { n: "05", title: "PERIOFLOW®", text: "Nelle tasche più profonde, da 4 a 9 mm, un ugello sottile e morbido pulisce delicatamente denti naturali e impianti." },
  { n: "06", title: "PIEZON® PS", text: "Solo dove resta tartaro, uno strumento a ultrasuoni mininvasivo lo rimuove con delicatezza, rispettando smalto e gengive." },
  { n: "07", title: "Controllo", text: "Verifichiamo che biofilm e tartaro siano stati eliminati del tutto. Nessuna lucidatura con paste abrasive: lo smalto resta intatto." },
  { n: "08", title: "Richiamo", text: "In base al tuo rischio individuale fissiamo la frequenza dei controlli: per molti ogni 3-6 mesi, per i pazienti parodontali più spesso." },
];

export const GBT_BENEFITS = [
  { title: "Più confortevole", text: "Acqua tiepida, polvere finissima e pochissimi ultrasuoni: ideale anche per chi ha denti sensibili o paura." },
  { title: "Rispetta lo smalto", text: "Niente pasta abrasiva e niente raschiamento superfluo: si protegge la superficie dei denti, delle otturazioni e degli impianti." },
  { title: "Più precisa", text: "Il rivelatore mostra ogni residuo di biofilm, così nulla sfugge e nulla viene trattato inutilmente." },
  { title: "Perfetta con impianti e apparecchi", text: "Pulisce in sicurezza impianti, faccette, corone e apparecchi ortodontici." },
];

export const GBT_CHECKLIST = [
  "Ti viene applicato un rivelatore di placca colorato prima della pulizia",
  "Si usa AIRFLOW® con polvere AIRFLOW® PLUS a base di eritritolo",
  "Gli ultrasuoni PIEZON® PS si usano solo dove resta tartaro",
  "Alla fine non viene passata una pasta abrasiva per lucidare",
  "Lo studio compare sul GBT Finder ufficiale",
];
